import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VehiclesConfigHubGuard } from './guard/vehicles-config-hub.guard';
import { VehiclesConfigVehiclesGuard } from './guard/vehicles-config-vehicles.guard';
import { LineDirectionCountersResetsListComponent } from
  './line-direction-counter-reset/components/line-direction-counters-resets-list/line-direction-counters-resets-list.component';
import { ResetStopsGuard } from './line-direction-counter-reset/reset-stops.guard';
import { VehiclesMenuComponent } from './vehicles-menu.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { LineDirectionCountersResetsAddComponent }
  from './line-direction-counter-reset/components/line-direction-counters-resets-add/line-direction-counters-resets-add.component';

const routes: Routes = [
  {
    path: '',
    component: VehiclesMenuComponent,
    canActivate: [VehiclesConfigHubGuard]
  },
  {
    path: 'vehicles',
    component: VehiclesComponent,
    canActivate: [VehiclesConfigVehiclesGuard]
  },
  {
    path: 'line-direction-counters-resets',
    canActivate: [ResetStopsGuard],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        component: LineDirectionCountersResetsListComponent,
        canActivate: [ResetStopsGuard]
      },
      {
        path: 'add',
        component: LineDirectionCountersResetsAddComponent,
        canActivate: [ResetStopsGuard]
      },
      {
        path: 'edit',
        component: LineDirectionCountersResetsAddComponent,
        canActivate: [ResetStopsGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VehiclesConfigRoutingModule { }
